/* Loumimi : après un ajout au panier, on rafraîchit le panier latéral et on l'ouvre (au lieu d'aller sur /cart). */
window.bbOpenCart = async function () {
  const INNER = '[data-hydration-key="cart-drawer-inner"]';
  const drawer = document.getElementById('cart-drawer');
  const cur = document.querySelector(INNER);
  if (!drawer || !cur) { window.location.href = '/cart'; return; }
  try {
    const [secRes, cartRes] = await Promise.all([
      fetch(window.location.pathname + '?sections=cart-drawer-section', { credentials: 'same-origin' }),
      fetch('/cart.js', { credentials: 'same-origin' })
    ]);
    const html = (await secRes.json())['cart-drawer-section'];
    const cart = await cartRes.json();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.querySelector(INNER);
    if (!next) throw new Error('no drawer');
    // Styles du tiroir absents quand la page a été chargée avec un panier vide
    doc.querySelectorAll('style').forEach((st, i) => {
      const id = 'bb-drawer-style-' + i;
      if (!document.getElementById(id)) { const el = document.createElement('style'); el.id = id; el.textContent = st.textContent; document.head.appendChild(el); }
    });
    document.querySelector(INNER).replaceWith(next);
    const icon = document.querySelector('cart-icon');
    if (icon && typeof icon.renderCartBubble === 'function') icon.renderCartBubble(cart.item_count);
    document.querySelectorAll('.theme-drawer__badge').forEach(b => { b.textContent = cart.item_count; b.classList.toggle('visually-hidden', cart.item_count === 0); });
    drawer.classList.remove('cart-drawer--empty');
    if (typeof drawer.open === 'function') drawer.open(); else drawer.setAttribute('open', '');
  } catch (e) { window.location.href = '/cart'; }
};

// Boutons « + prix » de l'upsell du panier (fonctionne aussi après rafraîchissement du tiroir)
document.addEventListener('click', async e => {
  const b = e.target.closest('[data-cup-add]');
  if (!b) return;
  e.preventDefault();
  b.disabled = true; b.textContent = 'Ajout…';
  try {
    const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +b.dataset.cupAdd, quantity: 1 }] }) });
    if (!r.ok) throw new Error(r.status);
    if (document.getElementById('cart-drawer') && b.closest('#cart-drawer')) await window.bbOpenCart(); else location.reload();
  } catch (err) { b.disabled = false; b.textContent = 'Réessayer'; }
});

/* Un cahier par commande avec un article payant, jusqu'au 1er décembre inclus. */
(function () {
  const G = window.bbGift; if (!G) return;
  const originalFetch = window.fetch.bind(window);
  const cartRoot = window.Shopify?.routes?.root || '/';
  let pending = null, again = false;
  async function post(path, body) {
    const res = await originalFetch(cartRoot + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    if (!res.ok) throw new Error('Gift cart update: ' + res.status);
    return res.json();
  }
  function sync() {
    if (pending) { again = true; return pending; }
    pending = (async () => {
      let changed = false;
      do {
        again = false;
        const res = await originalFetch(cartRoot + 'cart.js');
        if (!res.ok) throw new Error('Gift cart read: ' + res.status);
        let cart = await res.json();
        const bundleQty = cart.items.filter(i => i.handle === 'coffret-petites-mains').reduce((sum, i) => sum + i.quantity, 0);
        const boxQty = G.boxAvailable && Date.now() < Date.parse(G.endsAt) ? bundleQty : 0;
        const boxes = cart.items.filter(i => i.variant_id === G.boxId && i.properties?.Offert === 'Offre Noël');
        const boxUpdates = {};
        boxes.forEach((item, index) => { const qty = index === 0 ? boxQty : 0; if (item.quantity !== qty) boxUpdates[item.key] = qty; });
        if (Object.keys(boxUpdates).length) { await post('cart/update.js', { updates: boxUpdates }); changed = true; }
        if (boxQty && !boxes.length) { await post('cart/add.js', { items: [{ id: G.boxId, quantity: boxQty, properties: { Offert: 'Offre Noël' } }] }); changed = true; }
        if (Object.keys(boxUpdates).length || (boxQty && !boxes.length)) cart = await originalFetch(cartRoot + 'cart.js').then(r => r.json());
        const gifts = cart.items.filter(i => i.variant_id === G.id);
        const eligible = G.available && Date.now() < Date.parse(G.endsAt) && cart.items.some(i => i.variant_id !== G.id && i.final_line_price > 0);
        const updates = {};
        gifts.forEach((g, i) => { const qty = eligible && i === 0 ? 1 : 0; if (g.quantity !== qty) updates[g.key] = qty; });
        if (Object.keys(updates).length) { await post('cart/update.js', { updates }); changed = true; }
        if (eligible && !gifts.length) { await post('cart/add.js', { items: [{ id: G.id, quantity: 1, properties: { 'Cadeau': 'offert' } }] }); changed = true; }
      } while (again);
      if (changed && location.pathname === cartRoot + 'cart') location.reload();
      return changed;
    })().catch(error => { console.error('Cahier offert :', error); }).finally(() => { pending = null; });
    return pending;
  }
  window.fetch = function (input) {
    const result = originalFetch.apply(window, arguments);
    const url = typeof input === 'string' ? input : input?.url || String(input);
    if (!/\/cart\/(add|change|update|clear)/.test(url)) return result;
    return result.then(async response => { if (response.ok) await sync(); return response; });
  };
  window.bbGiftSync = sync;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();
